"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = videoData => {
    if (typeof window._satellite === 'undefined')
        return;
    if (typeof window.adobeDataLayer === 'undefined')
        return;
    const analyticsEvent = {};
    analyticsEvent.event = 'Global_AA_GA_Events_Video_50';
    analyticsEvent.videoInfo = {
        videoID: videoData.video_id || 'NA',
        videoName: videoData.video_name || 'NA',
        player: videoData.player || 'NA',
        category: videoData.category || 'NA',
    };
    analyticsEvent.component = {
        variant: videoData.componentVariant || 'NA',
    };
    window._satellite.track('Global_AA_GA_Events_Video_50', analyticsEvent.videoInfo);
    window.adobeDataLayer.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
